import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { CartState } from '@app/store/state/cart.state';

const SESSION_STORAGE_KEY = 'shop-current-step';

@Injectable({ providedIn: 'root' })
export class StepNavigationService<T> {
  constructor(private store: Store) {}

  saveStep(stepId: T): void {
    const cartId = this.store.selectSnapshot(CartState.getCartId());
    const accountId = this.store.selectSnapshot(CartState.getCurrentAccount)?.id;
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify({ cartId, step: stepId, accountId }));
  }

  getStep(): T {
    const cartId = this.store.selectSnapshot(CartState.getCartId());
    const accountId = this.store.selectSnapshot(CartState.getCurrentAccount)?.id;
    const savedStep = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY));
    return savedStep?.cartId === cartId && savedStep?.accountId === accountId ? savedStep.step : void 0;
  }

  resetSavedStep(): void {
    this.saveStep(void 0);
  }
}
